import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wall",
  "use": "icon-wall-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-wall\">\n  <path d=\"M341.20704 910.84288v-184.30464H75.22816V480.70656h265.97888V358.99392H75.22816V113.15712h605.5168l0.00512 184.29952h265.97376v245.8368h-265.97376v121.71264h265.97376V910.848H341.20704z m542.91968-62.59712V727.6032H403.80416v120.64256h480.32256z m-265.97888-184.29952v-120.64256H137.82528v120.64256h480.32256z m265.97888-183.24992V360.05376H403.80416v120.64256h480.32256zM618.14784 296.3968V175.75424H137.82528V296.3968h480.32256z\" p-id=\"10511\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wall.svg
// module id = M4jO
// module chunks = 12